import * as R from 'ramda'

export { stateManager }

function stateManager (initNeeded = {}, extras = {}) {
  return {
    get () {
      return R.merge(initNeeded, extras)
    },
    reset (target) {
      const assignInitVal = (v, k) => {
        target[k] = v
      }
      R.forEachObjIndexed(assignInitVal, R.clone(initNeeded))
    }
  }
}
